import apollo from 'graphql/apollo';
import { updateStaticItemMutation } from 'graphql/mutations';

const updateStaticItem = async ({ _id, name, value }) =>
  apollo.mutate({ mutation: updateStaticItemMutation, variables: { _id, modifier: { name, value: `${value}` } } });
export default updateStaticItem;
